/**
 * This show possible statuses for payments or refunds.
 *
 * This extends the statuses with:
 * - CAPTURE_ERROR
 * - CANCEL_ERROR
 * - FAILED (exists on refunds but not payments!)
 * - FAILED_UNRECOVERABLE
 *
 * To handle theses new states we need to GET device.action.status or GET payment.
 *
 * This hybrid object covers the states that we need to handle and update the user about.
 *
 * @see https://docs.pos.payyo.ch/docs/api-reference/payment/
 * @see https://docs.stripe.com/payments/paymentintents/lifecycle#intent-statuses
 */
const PayyoPaymentStatus = Object.freeze({
    CAPTURE_ERROR: 'CAPTURE_ERROR',
    CANCELED: 'canceled',
    // Note: American spelling.
    // The transaction has been cancelled by the user.
    CANCEL_ERROR: 'cancel_error',
    // There was an error while attempting to cancel.
    FAILED: 'payment_failed',
    // The payment has failed. It may be recoverable, but we don't know yet.
    FAILED_UNRECOVERABLE: 'failed_unrecoverable',
    // A refund has been requested but we don't know the final status yet.
    PENDING: 'pending',
    // The payment has failed. We have confirmed that it cannot be recovered by calling GET devices/{device_id}
    PROCESSING: 'processing',
    REQUIRES_ACTION: 'requires_action',
    REQUIRES_CAPTURE: 'requires_capture',
    // The payment has been authorized by contactless or pin but has not been captured yet.
    REQUIRES_CONFIRMATION: 'requires_confirmation', // Not used.
    REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
    // The payment request has been created but the customer has either not tried to pay yet or there was a recoverable
    // problem such as the wrong pin.
    SUCCEEDED: 'succeeded',
});

module.exports = PayyoPaymentStatus;
